import {
    defineStore,
} from 'pinia';
import {
    computed,
    reactive, toRefs,
} from 'vue';
import educationTypes from '../data/education-types.json';
import {
    createEducation,
} from '../models/Education';

export const EMPTY_EDUCATION = {
    category: {},
    completed: true,
    customType: '',
    description: '',
    end: null,
    focus: '',
    id: null,
    location: '',
    name: '',
    start: null,
    submitted: false,
    trainingCompany: null,
    title: '',
    type: {},
};
const emptyEducationFactory = () => ({ ...JSON.parse(JSON.stringify(EMPTY_EDUCATION)) });

function getCategory(type) {
    let category = {};
    Object.keys(educationTypes).some((key) => {
        const subCategory = educationTypes[key].find(x => x.id === type);

        if (!subCategory) return false;

        category = {
            id: key,
            label: key,
        };

        return true;
    });
    return category;
}

export const useEducationStore = defineStore('profile-educations', () => {
    const newEducation = reactive(emptyEducationFactory());
    const state = reactive({
        educations: [],
    });

    function clearNewRows() {
        const emptyEducation = emptyEducationFactory();
        Object.keys(newEducation).forEach((key) => {
            newEducation[key] = emptyEducation[key];
        });
    }

    function deleteById(id) {
        state.educations = state.educations.filter(x => x.id !== id);
    }

    function resetState() {
        Object.keys(state.educations).forEach((key) => {
            state[key] = { ...emptyEducationFactory()[key] };
        });
    }

    function updateFromQuery(data) {
        clearNewRows();
        // The default row is merged to make sure all necessary fields are initialized.
        state.educations = [
            ...data.map(education => ({
                ...EMPTY_EDUCATION,
                category: getCategory(education.type),
                completed: Boolean(education.completed),
                customType: education.customType,
                description: education.description,
                end: education.end,
                focus: education.focus,
                id: education.id,
                location: education.location,
                name: education.name,
                start: education.start,
                title: education.title,
                trainingCompany: education.trainingCompany,
                type: education.type ? {
                    id: education.type,
                    label: education.typeLabel,
                } : {},
            })),
        ];
    }

    const count = computed(() => state.educations.length);
    const filled = computed(() => state.educations.length > 0);
    const models = computed(() => [...state.educations, newEducation]
        .filter(x => x.id || x.submitted).map(x => createEducation(x)));

    return {
        ...toRefs(state),
        newEducation,
        delete: deleteById,
        resetState,
        $reset: resetState,
        clearNewRows,
        updateFromQuery,
        count,
        filled,
        models,
    };
});
